export default __webpack_public_path__ + "static/media/erp22.cf9295bb.png";